"use strict";
/**
 * Created on 07 03 2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var PriceTermination_1 = require("../../../price-termination/model/PriceTermination");

var SelloutTerminationSummary_1 = require("../../model/price-termination/SelloutTerminationSummary");

var SelloutTerminationSummaryItem_1 = require("../../model/price-termination/SelloutTerminationSummaryItem");

var SelloutTerminationSummaryConverter_1 = require("./SelloutTerminationSummaryConverter");
/**
 * <p>Implementation of {@link SelloutTerminationSummaryConverter}.</p>
 *
 * @author JMe
 */


var SelloutTerminationSummaryConverterImpl =
/*#__PURE__*/
function (_SelloutTerminationSu) {
  _inherits(SelloutTerminationSummaryConverterImpl, _SelloutTerminationSu);

  function SelloutTerminationSummaryConverterImpl() {
    _classCallCheck(this, SelloutTerminationSummaryConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(SelloutTerminationSummaryConverterImpl).apply(this, arguments));
  }

  _createClass(SelloutTerminationSummaryConverterImpl, [{
    key: "toDocument",

    /**
     * @inheritDoc
     */
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        terminationId: conversions.toDocumentReferenceId(source.terminationId),
        items: conversions.asObjectArray(source, 'items', this.serializeItemSummary(conversions))
      });
      return result;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toObject",
    value: function toObject(source, conversions) {
      return new SelloutTerminationSummary_1.SelloutTerminationSummary(conversions.documentToClassId(source), conversions.asObject(source, 'terminationId', function (v) {
        return conversions.toClassReferenceId(v);
      }), conversions.asObjectList(source, 'items', this.deserializeItemSummary(conversions)));
    }
  }, {
    key: "deserializeItemSummary",
    value: function deserializeItemSummary(conversions) {
      return function (source) {
        return new SelloutTerminationSummaryItem_1.SelloutTerminationSummaryItem(conversions.asObject(source, 'rId', function (v) {
          return conversions.toClassReferenceId(v);
        }), conversions.asObject(source, 'rName', function (v) {
          return v;
        }), conversions.asObject(source, 'pListType', function (v) {
          return v;
        }), conversions.asObject(source, 'workflowType', function (v) {
          return v;
        }), conversions.asObject(source, 'queueId', function (v) {
          return conversions.toClassReferenceId(v);
        }), conversions.asObjectOpt(source, 'progressId', function (v) {
          return conversions.toClassReferenceId(v);
        }), conversions.asObject(source, 'state', function (v) {
          return conversions.asEnum(v, PriceTermination_1.PriceTerminationState);
        }));
      };
    }
  }, {
    key: "serializeItemSummary",
    value: function serializeItemSummary(conversions) {
      return function (source) {
        return {
          rId: conversions.toDocumentReferenceId(source.rId),
          rName: source.rName,
          pListType: source.pListType,
          workflowType: source.workflowType,
          queueId: conversions.toDocumentReferenceId(source.queueId),
          progressId: conversions.asObjectOpt(source, 'progressId', function (v) {
            return conversions.toDocumentReferenceId(v);
          }),
          state: source.state
        };
      };
    }
  }]);

  return SelloutTerminationSummaryConverterImpl;
}(SelloutTerminationSummaryConverter_1.SelloutTerminationSummaryConverter);

exports.SelloutTerminationSummaryConverterImpl = SelloutTerminationSummaryConverterImpl;